// ResizeObserver "loop completed with undelivered notifications" is a benign
// scheduling signal Chrome emits whenever a ResizeObserver callback dirties
// layout — ReactFlow + several drag/resize widgets trigger it routinely.
// The browser handles it silently; the only reason it surfaces in dev is
// webpack-dev-server's runtime error overlay treats it as a crash.
//
// Filter it out at the window-level error handlers so the overlay never
// receives it. This runs only when the message matches; everything else
// bubbles through unchanged.
//
// Imported once from index.jsx alongside the other polyfills.

(function silenceResizeObserverLoopWarning() {
  if (typeof window === "undefined") return;

  const matches = (msg) =>
    typeof msg === "string" &&
    (msg.includes("ResizeObserver loop completed with undelivered notifications") ||
      msg.includes("ResizeObserver loop limit exceeded"));

  window.addEventListener(
    "error",
    (event) => {
      const msg = (event && event.message) || "";
      if (matches(msg)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      const reason = event && event.reason;
      const msg = reason && reason.message ? reason.message : String(reason || "");
      if (matches(msg)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );
})();
